import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import AuthProvider from './contexts/Auth';
import PedidosProvider from './contexts/Pedidos';
import ClientesProvider from './contexts/Clientes';
import RelatorioProvider from './contexts/Relatorios';
import LocalStorageProvider from './contexts/LocalStorage';
import Routes from './routes/Routes';
import ModalProvider from './contexts/Modals';
import 'bootstrap/dist/css/bootstrap.css';
import 'rc-datepicker/lib/style.css';
import './index.scss';

ReactDOM.render(
  <LocalStorageProvider>
    <ModalProvider>
      <AuthProvider>
        <PedidosProvider>
          <ClientesProvider>
            <RelatorioProvider>
              <BrowserRouter>
                <Routes />
              </BrowserRouter>
            </RelatorioProvider>
          </ClientesProvider>
        </PedidosProvider>
      </AuthProvider>
    </ModalProvider>
  </LocalStorageProvider>,
  document.getElementById('root')
);